import { createReportSnapshot, coverageSummary, emptyReportMessage, displayedDifferenceLabel } from "./checkReport";
export default function OrderDifferenceDetails({ review, processing = false, snapshot = createReportSnapshot(review, processing) }) {
    return <div className="table-scroll check-content" tabIndex={0} role="region" aria-label="Differences for this order">
        <div className="check-summary">
            <p>{processing ? coverageSummary(review, true) : snapshot?.summary ?? coverageSummary(review)}</p>
            <p className="check-difference-count">Items with differences: <span>{displayedDifferenceLabel(snapshot, processing)}</span></p>
        </div>
        {!processing && !snapshot?.products.length && <p>{emptyReportMessage(review, processing)}</p>}
        {snapshot?.products.map(product => <section key={product.productID} aria-label={`FS ProductID ${product.productID}`}>
            <h3 className="accent">FS ProductID {product.productID}</h3>
            <table><caption className="sr-only">Comparison for Front Systems product {product.productID}</caption>
                <thead><tr><th scope="col">Field</th><th scope="col">Front Systems</th><th scope="col">Incoming</th><th scope="col">Difference</th></tr></thead>
                <tbody>{product.rows.map(row => <tr key={row.key}>
                    <th scope="row">{row.label}</th><td title={row.beforeToken == null ? undefined : `Source token: ${row.beforeToken}`}>{row.before}</td>
                    <td title={row.incomingToken == null ? undefined : `Source token: ${row.incomingToken}`}>{row.incoming}</td><td title={row.note}>{row.difference}</td>
                </tr>)}</tbody>
            </table>
        </section>)}
    </div>;
}
